import React, { useState, useEffect } from "react";
import axios from "axios";
import Step4PaymentSelection from "./Step4PaymentSelection";
import Navbar from "./Navbar";
import Footer from "./Footer";

const API_BASE_URL = "https://api.rescons.in";

const PaymentPage = () => {
  const [formData, setFormData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const uid = sessionStorage.getItem("uid");
        if (!uid) {
          setError("User not logged in");
          setLoading(false);
          return;
        }

        const response = await axios.get(`${API_BASE_URL}/user-info/${uid}`);
        console.log("📋 PaymentPage fetched user data:", JSON.stringify(response.data, null, 2));
        console.log("📋 PaymentPage category1:", response.data.category1);
        setFormData(response.data);
      } catch (err) {
        console.error("Error fetching user data:", err);
        setError("Failed to load user data");
      } finally {
        setLoading(false);
      }
    };

    fetchUserData();
  }, []);

  const updateFormData = async (updatedFields) => {
    try {
      const uid = sessionStorage.getItem("uid");
      if (!uid) return;
      
      await axios.put(`${API_BASE_URL}/user-info/update/${uid}`, updatedFields);
      setFormData(prev => ({ ...prev, ...updatedFields }));
    } catch (error) {
      console.error("Error updating user info:", error);
    }
  };

  if (loading) {
    return (
      <>
        <Navbar />
        <div style={{ textAlign: 'center', padding: '50px' }}>Loading...</div>
        <Footer />
      </>
    );
  }

  if (error) {
    return (
      <>
        <Navbar />
        <div style={{ textAlign: 'center', padding: '50px', color: 'red' }}>Error: {error}</div>
        <Footer />
      </>
    );
  }

  if (!formData) {
    return (
      <>
        <Navbar />
        <div style={{ textAlign: 'center', padding: '50px' }}>No user data found</div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Navbar />
      <Step4PaymentSelection 
        formData={formData} 
        updateFormData={updateFormData} 
      />
      <Footer />
    </>
  );
};

export default PaymentPage; 